import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.707.293a1 1 0 1 0-1.414 1.414L18.586 4H7a5 5 0 0 0-5 5v2a1 1 0 1 0 2 0V9a3 3 0 0 1 3-3h11.586l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4A1 1 0 0 0 22 5zm0 0 4 4c.193.193.29.445.293.698zM22 15v-2a1 1 0 1 0-2 0v2a3 3 0 0 1-3 3H5.414l2.293-2.293a1 1 0 1 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L5.414 20H17a5 5 0 0 0 5-5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }